import { render, staticRenderFns } from "./ServiceDetailForm.vue?vue&type=template&id=69bce1c0&scoped=true&"
import script from "./ServiceDetailForm.vue?vue&type=script&lang=js&"
export * from "./ServiceDetailForm.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDetailForm.vue?vue&type=style&index=0&id=69bce1c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bce1c0",
  null
  
)

export default component.exports